import * as pathToRegexp from 'path-to-regexp';
import { ClassAttributes, createElement, FC, useContext } from 'react';
import ReactDocumentTitle from 'react-document-title';
import { context as StateContext } from '../context/state';

type Props = ClassAttributes<HTMLElement>;

const DocumentTitle: FC<Props> = () => {
  const state = useContext(StateContext);
  const location = state.location;
  let title: string | null = null;

  if (location.pathname === '/settings') {
    title = 'Settings';
  } else if (pathToRegexp('/creations/:creationId').test(location.pathname)) {
    title = 'Loading...';
  }

  if (title === null) {
    title = 'Kaizen Platform';
  } else {
    title = `${title} | Kaizen Platform`;
  }

  return <ReactDocumentTitle title={title} />;
};

export default DocumentTitle;
